var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-wrap greaty-home"},[_c('div',{staticClass:"clear"}),_c('div',{staticClass:"banner"},[_c('lottie',{staticClass:"on-screen"})],1),_c('div',{staticClass:"clear"})])}
var staticRenderFns = []

export { render, staticRenderFns }